// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child("clubs")
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });

        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-history/club-history-single/club-history-single-service.js